import { render, staticRenderFns } from "./ExpectedOrdersNew.vue?vue&type=template&id=7ed96976&lang=pug"
import script from "./ExpectedOrdersNew.vue?vue&type=script&lang=ts"
export * from "./ExpectedOrdersNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports